'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// import verifyIcon from 'assets/img/account/verifyIcon@3x.png';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _address2x = require('assets/img/account/address@2x.png');

var _address2x2 = _interopRequireDefault(_address2x);

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _plusExu3x = require('assets/img/account/plusExu@3x.png');

var _plusExu3x2 = _interopRequireDefault(_plusExu3x);

var _discountIcon2x = require('assets/img/common/discountIcon@2x.png');

var _discountIcon2x2 = _interopRequireDefault(_discountIcon2x);

var _lib = require('helpers/lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    location: state.user.coords,
    categories: state.setup.categories
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CardMobile, _Component);

  function CardMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CardMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardMobile.__proto__ || (0, _getPrototypeOf2.default)(CardMobile)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _this.onClick = function () {
      var _this$props = _this.props,
          tracking = _this$props.tracking,
          shop = _this$props.shop,
          manualTrack = _this$props.manualTrack;

      if (manualTrack) manualTrack((0, _extends3.default)({}, tracking, { shopId: shop.id }));
      _reactGa2.default.event({
        category: 'Shop',
        action: 'Clicked Shop Card',
        label: _this.props.shop.name + ' (' + _this.props.shop._id + ')'
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CardMobile, [{
    key: 'render',
    value: function render() {
      var styles = require('./CardMobile.scss');
      var _props = this.props,
          shop = _props.shop,
          location = _props.location,
          user = _props.user,
          customStyle = _props.customStyle;

      var reviews = shop && shop.review && shop.review.length > 1 && shop.reviews.reverse() || [];
      var reviewsRender = reviews.filter(function (r) {
        return r.status === 'available' || (user && user._id) === (r.user && r.user._id);
      });
      var distance = 0;
      if (location && location.latitude && shop && shop.location) {
        distance = Math.round((0, _lib.getDistanceFromLatLon)(shop.location.lat, shop.location.lng, location.latitude, location.longitude));
        if (distance < 1000) {
          distance = distance + 'm';
        } else {
          distance = Math.round(distance / 1000 * 10) / 10;
          distance = distance.toFixed(1);
          distance += 'km';
        }
      }
      var averagePoint = shop && shop.averagePoint || 0;
      var colorRatingCode = (0, _lib.getColorRatingCode)(averagePoint);
      var stylePoint = {
        backgroundColor: colorRatingCode
      };
      return _react2.default.createElement(
        'div',
        { className: styles.item, style: customStyle },
        shop ? _react2.default.createElement(
          _reactRouter.Link,
          {
            to: shop.handle,
            onClick: this.onClick,
            style: { color: '#666' }
          },
          _react2.default.createElement(
            'div',
            { className: styles.cardMobile },
            _react2.default.createElement(
              'div',
              { className: styles.thumbnail },
              _react2.default.createElement(
                _reactLazyload2.default,
                { height: 185 },
                _react2.default.createElement('img', {
                  src: (0, _lib.getUrlImage)(shop.image),
                  className: styles.thumbnailImg,
                  onError: this.onErrorImage
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.bottomLeftView,
                  style: shop.isBooking ? { backgroundColor: '#8EBA0B' } : null
                },
                _react2.default.createElement(
                  'div',
                  { className: styles.bottomLeftText },
                  shop.isBooking ? 'Booking' : 'Review'
                )
              ),
              shop.isHavePromotion && _react2.default.createElement(
                'div',
                { className: styles.topRightView },
                _react2.default.createElement(
                  'div',
                  { className: styles.topRightText },
                  'C\xF3 \u01B0u \u0111\xE3i'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.point, style: stylePoint },
                averagePoint !== 0 ? averagePoint.toFixed(1) : '--'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.cardHeader },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement(
                  'div',
                  { className: styles.category },
                  this.props.categories && shop.category && (0, _lib.paserCategory)(this.props.categories, shop.category)
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.nameView },
                  _react2.default.createElement(
                    'div',
                    {
                      className: styles.name + ' ' + (shop.isChain && shop.numOfBranch && shop.numOfBranch > 1 && styles.width200)
                    },
                    shop.name
                  ),
                  !!(shop.isChain && shop.numOfBranch && shop.numOfBranch > 1) && _react2.default.createElement(
                    'div',
                    { className: styles.numBranch },
                    '(',
                    shop.numOfBranch,
                    ' chi nh\xE1nh)'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.addressView },
                  _react2.default.createElement('img', { src: _address2x2.default, className: styles.addressIcon }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.address },
                    shop.addressDisplay ? shop.addressDisplay : shop.address
                  )
                ),
                shop.isDiscountByTime && _react2.default.createElement(
                  'div',
                  { className: styles.discountView },
                  _react2.default.createElement('img', { className: styles.discountIcon, src: _discountIcon2x2.default }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.discountText },
                    '\u0110ang c\xF3 khuy\u1EBFn m\xE3i theo khung gi\u1EDD'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.right + (reviewsRender.length === 0 ? ' ' + styles.flexEnd : '')
                },
                _react2.default.createElement(
                  'div',
                  { className: styles.borderBottom },
                  _react2.default.createElement('div', null)
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.addInfo },
                  _react2.default.createElement(
                    'div',
                    { className: styles.addInfoItem },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'heart' })
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      shop.totalLike
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.addInfoItem },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'comment' })
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      reviewsRender.length
                    )
                  ),
                  location && shop && location.latitude && shop.location && _react2.default.createElement(
                    'div',
                    {
                      className: styles.addInfoItem + ' ' + styles.distanceInfo,
                      style: { marginLeft: 0 }
                    },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_reactBootstrap.Glyphicon, {
                        className: styles.icon,
                        glyph: 'map-marker'
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      distance
                    )
                  )
                )
              )
            ),
            reviewsRender.length > 0 ? _react2.default.createElement(
              'div',
              { className: styles.comments },
              _react2.default.createElement(
                'div',
                { className: styles.comment },
                _react2.default.createElement(
                  'div',
                  { className: styles.avatarCmt },
                  _react2.default.createElement(
                    _reactLazyload2.default,
                    { height: 40 },
                    _react2.default.createElement('img', {
                      src: (0, _lib.getAvatar)(reviewsRender[0].user),
                      onError: this.onErrorImage
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.nameContent },
                  _react2.default.createElement(
                    'div',
                    { className: styles.nameView },
                    _react2.default.createElement(
                      'div',
                      { className: styles.name },
                      reviewsRender[0].user && reviewsRender[0].user.profile && reviewsRender[0].user.profile.name ? reviewsRender[0].user.profile.name : 'Vô danh'
                    ),
                    _react2.default.createElement('div', { className: styles.dot }),
                    _react2.default.createElement(
                      'div',
                      { className: styles.date },
                      reviewsRender[0].createdAt ? (0, _lib.formatDate)(reviewsRender[0].createdAt) : null
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.contentCmt },
                    reviewsRender[0].comment
                  )
                )
              )
            ) : _react2.default.createElement(
              'div',
              { className: styles.placeHolderView },
              _react2.default.createElement(
                'div',
                { className: styles.placeHolderImg },
                _react2.default.createElement('img', { src: _plusExu3x2.default, onError: this.onErrorImage })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.nameContent },
                _react2.default.createElement(
                  'div',
                  { className: styles.placeholderCmt },
                  'H\xE3y chia s\u1EBB tr\u1EA3i nghi\u1EC7m c\u1EE7a b\u1EA1n v\u1EC1 d\u1ECBch v\u1EE5 v\xE0 nh\u1EADn t\u1ED1i \u0111a 150 exu cho m\u1ED7i \u0111\xE1nh gi\xE1'
                )
              )
            )
          )
        ) : null
      );
    }
  }]);
  return CardMobile;
}(_react.Component), _class2.propTypes = {
  customStyle: _react.PropTypes.any,
  user: _react.PropTypes.object,
  className: _react.PropTypes.string,
  shop: _react.PropTypes.object,
  location: _react.PropTypes.object,
  tracking: _react.PropTypes.object,
  categories: _react.PropTypes.array,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = CardMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Box/CardMobile.js
// module id = 1538
// module chunks = 0